import React from 'react';
import { Card, CardContent } from './ui/card';
import { Bike, Dumbbell, Zap, ArrowRight } from 'lucide-react';
import { spinfitData, clubData } from '../data/mock';

export const SpinfitHero = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#39FF14]/20 via-black to-black relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 animate-pulse">
          <Bike className="w-32 h-32 text-[#39FF14]" />
        </div>
        <div className="absolute bottom-20 right-10 animate-pulse delay-75">
          <Dumbbell className="w-32 h-32 text-[#39FF14]" />
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Title Badge */}
          <div className="text-center mb-8">
            <div className="inline-block bg-[#39FF14] text-black px-6 py-2 rounded-full font-black text-sm mb-4 animate-bounce">
              🆕 NOVA CLASSE
            </div>
            <h2 className="text-5xl md:text-7xl font-black text-white mb-4">
              <span className="text-[#39FF14]">{spinfitData.emoji}</span>
              <br />
              {spinfitData.tagline}
            </h2>
            <p className="text-2xl md:text-3xl text-gray-300 font-bold">
              {spinfitData.description}
            </p>
          </div>

          {/* How it Works */}
          <Card className="bg-gradient-to-br from-gray-900 to-black border-2 border-[#39FF14] shadow-2xl shadow-[#39FF14]/20 mb-8">
            <CardContent className="p-8 md:p-12">
              <div className="space-y-6">
                {spinfitData.howItWorks.map((text, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="bg-[#39FF14] rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                      <span className="text-black font-bold">{index + 1}</span>
                    </div>
                    <p className="text-gray-300 text-lg leading-relaxed">{text}</p>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-gray-900/50 border-2 border-[#39FF14]/30 hover:border-[#39FF14] transition-all">
              <CardContent className="p-6 text-center">
                <Bike className="w-12 h-12 text-[#39FF14] mx-auto mb-3" />
                <h3 className="text-white font-bold text-lg mb-2">50% Spinning</h3>
                <p className="text-gray-400 text-sm">Cardio intensiu i resistència</p>
              </CardContent>
            </Card>

            <Card className="bg-gray-900/50 border-2 border-[#39FF14]/30 hover:border-[#39FF14] transition-all">
              <CardContent className="p-6 text-center">
                <Dumbbell className="w-12 h-12 text-[#39FF14] mx-auto mb-3" />
                <h3 className="text-white font-bold text-lg mb-2">50% Fit</h3>
                <p className="text-gray-400 text-sm">Força i exercicis funcionals</p>
              </CardContent>
            </Card>

            <Card className="bg-gray-900/50 border-2 border-[#39FF14]/30 hover:border-[#39FF14] transition-all">
              <CardContent className="p-6 text-center">
                <Zap className="w-12 h-12 text-[#39FF14] mx-auto mb-3" />
                <h3 className="text-white font-bold text-lg mb-2">100% Efectiu</h3>
                <p className="text-gray-400 text-sm">Resultats en menys temps</p>
              </CardContent>
            </Card>
          </div>

          {/* Final CTA */}
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-black text-white mb-6">
              🔥 {spinfitData.taglineFinal} 🔥
            </p>
            <a
              href={clubData.reservationForm}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 bg-[#39FF14] hover:bg-[#2EDD0F] text-black px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl shadow-[#39FF14]/50"
            >
              Reserva la Teva Plaça
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
